import { useState, useEffect } from 'react';
import { encodeStorage, decodeStorage } from './storageBase64'
import { getCookie } from './getCookie'

export function useValidateSession(){

    const [sessionCookie, setSessionCookie ] = useState()
    const [cartCookie, setCartCookie ] = useState()
    const [tokenCookie, setTokenCookie ] = useState()
    const [tokenRCookie, setTokenRCookie ] = useState()
    const [sessionStore, setSessionStore ] = useState()
    const [cartStore, setCartStore ] = useState()
    const [tokenStore, setTokenStore] = useState()
    const [tokenRStore, setTokenRStore] = useState()
    const [profileData, setProfileData ] = useState()
    const [tokenTime, setTokenTime ] = useState()
    const [tokenTimeR, setTokenTimeR ] = useState()

    const [updateFunction, setUpdateFunction] = useState(false)

    const [actTime, setActTime ] = useState( Date.now() )
    const [atExp, setAtExp ] = useState( tokenTime * 1000 )
    const [rtExp, setRtExp ] = useState(  tokenTimeR * 1000 )

    useEffect(()=>{
        setSessionCookie( getCookie('token_login') )
        setCartCookie( getCookie('token_cart') )
        setTokenCookie(getCookie('access_token') )
        setTokenRCookie( getCookie('refresh_token') )
        setSessionStore( decodeStorage('session_token') )
        setCartStore( decodeStorage('idCarrito') )
        setTokenStore( decodeStorage('access_token') )
        setTokenRStore( decodeStorage('refresh_token') )
        setProfileData( decodeStorage('profileData') )
        setTokenTime( decodeStorage('access_token_exp') )
        setTokenTimeR( decodeStorage('refresh_token_exp') )
        //let dominio = window.location.host
        //const domain = dominio.replace(dominio.split('.')[0], '')
        
    },[])

    const [session, setSession] = useState(null)
    useEffect(()=>{
        if(decodeStorage("access_token")){
            setSession(decodeStorage("access_token"))
        }
        else{
            setSession(false)
        }
    },[session])

    /*  Si existe storage toma los datos, si no existe busca datos de la cookie y los guarda al storage  */
    useEffect(()=>{

        setActTime( Date.now() )
        setAtExp( decodeStorage('access_token_exp') * 1000 )
        setRtExp( tokenTimeR * 1000 )

        // console.log('----------------------------------')
        // console.log('sessionStore: ',sessionStore)
        // console.log('cartStore: ',cartStore)
        // console.log('tokenStore: ',tokenStore)
        // console.log('tokenRStore: ',tokenRStore)
        // console.log('----------------------------------')
        
        
        if(sessionStore && cartStore){
            let domain = window.location.hostname

            setUpdateFunction(false)
            if(!sessionCookie && !cartCookie){
                document.cookie = `token_cart=${cartStore};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                document.cookie = `token_login=${sessionStore};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
            }
            if(tokenStore && tokenRStore){
                if(!tokenCookie && !tokenRCookie){
                    // console.log('Existe storage pero no las cookies de token')
                    document.cookie = `access_token=${tokenStore};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                    document.cookie = `refresh_token=${tokenRStore};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`

                }
            }
        }
        else{
            // console.log('No existe ni cookie ni storage')
            setUpdateFunction(false)
        }

    },[updateFunction])

    const checkValidateSession = () => setUpdateFunction(true)

    return { checkValidateSession, atExp, rtExp, actTime, session }
}